import { isServer } from '../../config';

export function removeQueryParams(params: string[]) {
  if (isServer) return;

  const url = new URL(window.location.href);

  for (const param of params) {
    url.searchParams.delete(param);
  }

  const relativeUrl = url.toString().split(window.location.origin)[1];
  window.history.replaceState(window.history.state, '', relativeUrl);
}
